'use client';

import { useRef, useState, useEffect } from "react";
function useWaitOneFrame() {
  const mountedRef = useRef(false);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (mountedRef.current) {
      setMounted(true);
    }
    const frame = requestAnimationFrame(() => {
      mountedRef.current = true;
      setMounted(true);
    });
    return () => cancelAnimationFrame(frame);
  }, []);
  return mounted;
}
export {
  useWaitOneFrame
};
